import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bell-off",
  "use": "bell-off-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"bell-off\"><path fill=\"none\" stroke=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16.045 24.636a2.364 2.364 0 0 1-4.09 0m9.88-9.454a21.143 21.143 0 0 1-.744-5.91M7.216 7.216a6.925 6.925 0 0 0-.307 2.057c0 8.272-3.545 10.636-3.545 10.636h16.545M21.09 9.273a7.09 7.09 0 0 0-11.025-5.91M1 1l26 26\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol